import { Notification } from 'element-ui';
import UX from '../utils/ux';

export default {
    computed: {
        computedSubmitButtonLabel() {
            return this.isProcessing
                ? 'Please wait...'
                : this.submitButtonLabel
        },
    },

    methods: {
        resetForm(formName) {
            this.$refs[formName].resetFields();
        },

        formFailure(response, formName = 'elForm') {
            if (response.status === 422 || response.status === 409) {
                this.formValidationFailed(response.data.errors, formName)
            } else {
                this.notifyGeneralError('Something went wrong! Please try again or contact us.');
            }
        },

        formValidationFailed(errors, formName = 'elForm') {
            _.each(this.$refs[formName].fields, field => {
                const prop = field.$options.propsData.prop;

                const error = errors[prop];

                if (error) {
                    field.validateState = 'error';
                    field.validateMessage = error[0] || 'This field is invalid';
                }
            });
        },

        notifyGeneralError(message, duration = 0) {
            Notification.error({
                title: 'Opps!',
                message: message,
                duration,
                customClass: 'is-error'
            })
        },

        scrollToError(formName) {
            const firstError = _.find(this.$refs[formName].fields, field => field.validateState === 'error');
            UX.scrollTo(firstError.$el, .5, 50);
        },
    },
}